var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let BreadDifference = class BreadDifference extends Vue {
    constructor() {
        super(...arguments);
        this.inputCurrentValue = null;
        this.updatedRecipe = null;
        this.updatedTourGroup = null;
        this.updatedClientsRecipes = null;
        this.invalid = false;
    }
    get currentValue() {
        if (this.inputCurrentValue !== null) {
            const num = Number(this.inputCurrentValue);
            if (!isNaN(num) && Number.isInteger(num)) {
                return num;
            }
        }
        return null;
    }
    get quantity() {
        return this.computedClientsRecipes
            .filter(cr => cr.recipe_id === this.computedRecipe.id)
            .reduce((carry, cr) => {
            return carry + cr.qty;
        }, 0);
    }
    get real_quantity() {
        var _a;
        return this.quantity + ((_a = this.computedRecipe.quantity_difference) !== null && _a !== void 0 ? _a : 0);
    }
    get computedRecipe() {
        return this.updatedRecipe || this.recipe;
    }
    get computedTourGroup() {
        return this.updatedTourGroup || this.tourGroup;
    }
    get computedClientsRecipes() {
        return this.updatedClientsRecipes || this.clientsRecipes;
    }
    mounted() {
        if (this.recipe.quantity_difference) {
            this.inputCurrentValue = `${this.recipe.quantity_difference}`;
        }
    }
    isValid() {
        if (this.inputCurrentValue !== null) {
            const num = Number(this.inputCurrentValue);
            if (isNaN(num) || !Number.isInteger(num)) {
                return false;
            }
        }
        return true;
    }
    markValid() {
        this.invalid = false;
    }
    markInvalid() {
        this.invalid = true;
    }
    hasChange() {
        return this.currentValue !== this.recipe.quantity_difference;
    }
    get() {
        return { recipe: this.recipe.id, quantity: this.currentValue };
    }
};
__decorate([
    Prop()
], BreadDifference.prototype, "recipe", void 0);
__decorate([
    Prop()
], BreadDifference.prototype, "tourGroup", void 0);
__decorate([
    Prop()
], BreadDifference.prototype, "clientsRecipes", void 0);
BreadDifference = __decorate([
    Component
], BreadDifference);
export default BreadDifference;
